import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";

import { FramerTooltip } from "@ryde/controls";
import { LiveMapRideFilterEnum, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { LiveMapRideFilterDropdownWrapper } from "./live-map-ride-filter.dropdown.styled";
import { LiveMapRideFilterDropdownArea } from "./parts/live-map-ride-filter.dropdown-area";
import { LiveMapRideFilterIcon } from "./parts/live-map-ride-filter.icon";
import { useLiveMapRideFilterDropdown } from "./parts/use-live-map-ride-filter-dropdown";

export const LiveMapRideFilterDropdown: FC = () => {
  const hookData = useLiveMapRideFilterDropdown();
  const { anchorRef, effectiveRideFilter, togglePopover, tooltipContent } =
    hookData;

  return (
    <LiveMapRideFilterDropdownWrapper>
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.top}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <button
          type="button"
          ref={anchorRef}
          className="live-map-ride-filter-trigger"
          data-e2e="live-map-ride-filter-trigger"
          aria-label={tooltipContent}
          onClick={togglePopover}
        >
          <LiveMapRideFilterIcon
            filter={effectiveRideFilter}
            className={
              effectiveRideFilter === LiveMapRideFilterEnum.all
                ? "live-map-ride-filter-icon--muted"
                : "live-map-ride-filter-icon--active"
            }
          />
        </button>
      </FramerTooltip>
      <LiveMapRideFilterDropdownArea hookData={hookData} />
    </LiveMapRideFilterDropdownWrapper>
  );
};
